<template>
  <v-row>
    <v-col cols="8">
      <div class="d-flex justify-space-between">
        <h1 class="titleSt">Componente Detalhamento Veículo</h1>
        <a class="text-decoration-none">
          <v-btn class="text-white" color="grey" @click="$emit('close-modal')">Cancelar</v-btn>
          <v-btn class="text-white" color="#ff5000" @click="store" v-bind:disabled="btn_disabled">Salvar</v-btn>
        </a>
      </div>
      <div class="mainInputs">
        <v-text-field v-model="fragmentId" label="ID do componente" hide-details="auto" @keyup="onInputChange()"></v-text-field>
      </div>
      <div class="mainInputs">
        <v-text-field v-model="title" label="Título" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
      </div>

      <div>
        <br />
        <hr />
        <h2>Classificação</h2>
        <div>
          <div v-for="item in classifications" :key="item.id" class="mainInputs">
            <div class="d-flex justify-space-between align-center mb-2">
              <h3>Classificação {{ item.id }}</h3>
              <v-btn v-if="item.id != 1" color="red" size="small" @click="removeClassificationItem(item.id)">
                <v-icon>mdi-delete</v-icon>
                Remover
              </v-btn>
            </div>
            <v-text-field v-model="item.fragmentClassificationId" label="ID da classificação" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-text-field v-model="item.classification" label="Classificação" :rules="classificationRules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-switch v-model="item.required" :color="movida_color" @change="onInputChange()" :label="'Preenchimento obrigatório? ' + (item.required ? 'Sim' : 'Não')"></v-switch>
          </div>
          <v-btn @click="addClassificationItem" color="primary" class="mt-2">
            <v-icon>mdi-plus</v-icon>
            Adicionar classificação
          </v-btn>
        </div>
      </div>

      <div>
        <br />
        <hr />
        <h2>Combustível</h2>
        <div>
          <div v-for="item in fuelTypes" :key="item.id" class="mainInputs">
            <div class="d-flex justify-space-between align-center mb-2">
              <h3>Combustível {{ item.id }}</h3>
              <v-btn v-if="item.id != 1" color="red" size="small" @click="removeFuelTypeItem(item.id)">
                <v-icon>mdi-delete</v-icon>
                Remover
              </v-btn>
            </div>
            <v-text-field v-model="item.fragmentFuelTypeId" label="ID do combustível" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-text-field v-model="item.fuelType" label="Tipo de Combustível" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-switch v-model="item.required" :color="movida_color" @change="onInputChange()" :label="'Preenchimento obrigatório? ' + (item.required ? 'Sim' : 'Não')"></v-switch>
          </div>
          <v-btn @click="addFuelTypeItem" color="primary" class="mt-2">
            <v-icon>mdi-plus</v-icon>
            Adicionar combustível
          </v-btn>
        </div>
      </div>

      <div>
        <br />
        <hr />
        <h2>Transmissão</h2>
        <div>
          <div v-for="item in transmissions" :key="item.id" class="mainInputs">
            <div class="d-flex justify-space-between align-center mb-2">
              <h3>Transmissão {{ item.id }}</h3>
              <v-btn v-if="item.id != 1" color="red" size="small" @click="removeTransmissionItem(item.id)">
                <v-icon>mdi-delete</v-icon>
                Remover
              </v-btn>
            </div>
            <v-text-field v-model="item.fragmentTransmissionId" label="ID da transmissão" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-text-field v-model="item.transmission" label="Tipo de Transmissão" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-switch v-model="item.required" :color="movida_color" @change="onInputChange()" :label="'Preenchimento obrigatório? ' + (item.required ? 'Sim' : 'Não')"></v-switch>
          </div>
          <v-btn @click="addTransmissionItem" color="primary" class="mt-2">
            <v-icon>mdi-plus</v-icon>
            Adicionar transmissão
          </v-btn>
        </div>
      </div>

      <div>
        <br />
        <hr />
        <h2>Text Input</h2>
        <div>
          <div v-for="item in textInputs" :key="item.id" class="mainInputs">
            <div class="d-flex justify-space-between align-center mb-2">
              <h3>Text Input {{ item.id }}</h3>
              <v-btn v-if="item.id != 1" color="red" size="small" @click="removeTextInputItem(item.id)">
                <v-icon>mdi-delete</v-icon>
                Remover
              </v-btn>
            </div>
            <v-text-field v-model="item.fragmentTextInputId" label="ID do text input" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-text-field v-model="item.label" label="Label do campo" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-switch v-model="item.required" :color="movida_color" @change="onInputChange()" :label="'Preenchimento obrigatório? ' + (item.required ? 'Sim' : 'Não')"></v-switch>
          </div>
          <v-btn @click="addTextInputItem" color="primary" class="mt-2">
            <v-icon>mdi-plus</v-icon>
            Adicionar text input
          </v-btn>
        </div>
      </div>

      <div>
        <br />
        <hr />
        <h2>Text Area Input</h2>
        <div>
          <div v-for="item in textAreaInputs" :key="item.id" class="mainInputs">
            <div class="d-flex justify-space-between align-center mb-2">
              <h3>Text Area Input {{ item.id }}</h3>
              <v-btn v-if="item.id != 1" color="red" size="small" @click="removeTextAreaInputItem(item.id)">
                <v-icon>mdi-delete</v-icon>
                Remover
              </v-btn>
            </div>
            <v-text-field v-model="item.fragmentTextAreaInputId" label="ID do text area input" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-text-field v-model="item.label" label="Label do campo" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-switch v-model="item.required" :color="movida_color" @change="onInputChange()" :label="'Preenchimento obrigatório? ' + (item.required ? 'Sim' : 'Não')"></v-switch>
          </div>
          <v-btn @click="addTextAreaInputItem" color="primary" class="mt-2">
            <v-icon>mdi-plus</v-icon>
            Adicionar text area input
          </v-btn>
        </div>
      </div>
    </v-col>

    <v-col cols="4">
      <custom-img-component :imageSrc="imageSrc" />
    </v-col>
  </v-row>

  <v-snackbar v-model="snackbar" :timeout="timeout">
    <v-icon class="ml-1"> mdi-information-outline </v-icon> {{ text }}
    <template v-slot:actions>
      <v-btn variant="text" @click="closeSnack"> Fechar </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import messages from "@/constants/messages";
import CustomImgComponent from "@/components/CustomImg/CustomImgComponent.vue";

@Options({
  components: {
    CustomImgComponent,
  },
})
export default class VehicleDetailsComponent extends Vue {
  public rules = [(value: any) => !!value || "Required.", (value: string) => (value && value.length >= 3) || "Min 3 characters"];
  public classificationRules = [(value: any) => !!value || "Required.", (value: string) => (value && value.length >= 1) || "Min 1 character"];
  public title = "";
  public fragmentId = "";
  public typeFragment = "CustomVehicleDetailsFragment";
  public messages: any = {};
  public isLoadingTable = true;
  public needleSearch: any;
  public snackbar = false;
  public text = "";
  public timeout = 10000;
  public btn_disabled = true;
  public generatedJson: any;
  public form: any;
  public movida_color = "#ff5000";
  // public imageSrc = require("@/assets/CustomComponentsImgExamples/VehicleDetails.png");

  // Classificações
  public classifications: Array<{
    id: number;
    classification: string;
    fragmentClassificationId: string;
    required: boolean;
  }> = [
    {
      id: 1,
      classification: "",
      fragmentClassificationId: "",
      required: false,
    },
  ];
  public nextClassificationId = 2;

  // Tipos de Combustível
  public fuelTypes: Array<{
    id: number;
    fuelType: string;
    fragmentFuelTypeId: string;
    required: boolean;
  }> = [
    {
      id: 1,
      fuelType: "",
      fragmentFuelTypeId: "",
      required: false,
    },
  ];
  public nextFuelTypeId = 2;

  // Transmissões
  public transmissions: Array<{
    id: number;
    transmission: string;
    fragmentTransmissionId: string;
    required: boolean;
  }> = [
    {
      id: 1,
      transmission: "",
      fragmentTransmissionId: "",
      required: false,
    },
  ];
  public nextTransmissionId = 2;

  // Text Inputs
  public textInputs: Array<{
    id: number;
    label: string;
    fragmentTextInputId: string;
    required: boolean;
  }> = [
    {
      id: 1,
      label: "",
      fragmentTextInputId: "",
      required: false,
    },
  ];
  public nextTextInputId = 2;

  // Text Area Inputs
  public textAreaInputs: Array<{
    id: number;
    label: string;
    fragmentTextAreaInputId: string;
    required: boolean;
  }> = [
    {
      id: 1,
      label: "",
      fragmentTextAreaInputId: "",
      required: false,
    },
  ];
  public nextTextAreaInputId = 2;

  mounted(): void {
    this.messages = messages;
    this.$emit("mounted", this);
  }

  changeLoading(): void {
    this.isLoadingTable = !this.isLoadingTable;
  }

  closeSnack(): void {
    this.snackbar = false;
  }

  onInputChange() {
    this.btn_disabled = true;
    this.verifyBtnDisabled();
  }

  verifyBtnDisabled() {
    const hasValidTitle = this.title?.length >= 3;
    const hasValidClassifications = this.classifications.every((item) => item.classification?.length >= 1);
    const hasValidFuelTypes = this.fuelTypes.every((item) => item.fuelType?.length >= 3);
    const hasValidTransmissions = this.transmissions.every((item) => item.transmission?.length >= 3);
    const hasValidTextInputs = this.textInputs.every((item) => item.label?.length >= 3);
    const hasValidTextAreaInputs = this.textAreaInputs.every((item) => item.label?.length >= 3);

    if (hasValidTitle && hasValidClassifications && hasValidFuelTypes && hasValidTransmissions && hasValidTextInputs && hasValidTextAreaInputs) {
      this.btn_disabled = false;
    }
    return this.btn_disabled;
  }

  // Métodos para Classificações
  addClassificationItem() {
    this.classifications.push({
      id: this.nextClassificationId,
      classification: "",
      fragmentClassificationId: "",
      required: false,
    });
    this.nextClassificationId++;
    this.btn_disabled = true;
  }

  removeClassificationItem(id: number) {
    const index = this.classifications.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.classifications.splice(index, 1);
      this.verifyBtnDisabled();
    }
  }

  // Métodos para Tipos de Combustível
  addFuelTypeItem() {
    this.fuelTypes.push({
      id: this.nextFuelTypeId,
      fuelType: "",
      fragmentFuelTypeId: "",
      required: false,
    });
    this.nextFuelTypeId++;
    this.btn_disabled = true;
  }

  removeFuelTypeItem(id: number) {
    const index = this.fuelTypes.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.fuelTypes.splice(index, 1);
      this.verifyBtnDisabled();
    }
  }

  // Métodos para Transmissões
  addTransmissionItem() {
    this.transmissions.push({
      id: this.nextTransmissionId,
      transmission: "",
      fragmentTransmissionId: "",
      required: false,
    });
    this.nextTransmissionId++;
    this.btn_disabled = true;
  }

  removeTransmissionItem(id: number) {
    const index = this.transmissions.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.transmissions.splice(index, 1);
      this.verifyBtnDisabled();
    }
  }

  // Métodos para Text Inputs
  addTextInputItem() {
    this.textInputs.push({
      id: this.nextTextInputId,
      label: "",
      fragmentTextInputId: "",
      required: false,
    });
    this.nextTextInputId++;
    this.btn_disabled = true;
  }

  removeTextInputItem(id: number) {
    const index = this.textInputs.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.textInputs.splice(index, 1);
      this.verifyBtnDisabled();
    }
  }

  // Métodos para Text Area Inputs
  addTextAreaInputItem() {
    this.textAreaInputs.push({
      id: this.nextTextAreaInputId,
      label: "",
      fragmentTextAreaInputId: "",
      required: false,
    });
    this.nextTextAreaInputId++;
    this.btn_disabled = true;
  }

  removeTextAreaInputItem(id: number) {
    const index = this.textAreaInputs.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.textAreaInputs.splice(index, 1);
      this.verifyBtnDisabled();
    }
  }

  public updateAttributes(data: any) {
    this.title = data.title;
    this.fragmentId = data.fragmentId || "";

    // Carregar Classificações
    this.classifications.splice(0, 1);
    let nextClassificationId = 1;
    if (data.vehicleDetails?.classifications && Array.isArray(data.vehicleDetails.classifications)) {
      data.vehicleDetails.classifications.forEach((classification: any) => {
        this.classifications.push({
          id: nextClassificationId,
          classification: classification.classification,
          fragmentClassificationId: classification.fragmentClassificationId || "",
          required: classification.required || false,
        });
        nextClassificationId++;
      });
    }

    // Carregar Tipos de Combustível
    this.fuelTypes.splice(0, 1);
    let nextFuelTypeId = 1;
    if (data.vehicleDetails?.fuelTypes && Array.isArray(data.vehicleDetails.fuelTypes)) {
      data.vehicleDetails.fuelTypes.forEach((fuelType: any) => {
        this.fuelTypes.push({
          id: nextFuelTypeId,
          fuelType: fuelType.fuelType,
          fragmentFuelTypeId: fuelType.fragmentFuelTypeId || "",
          required: fuelType.required || false,
        });
        nextFuelTypeId++;
      });
    }

    // Carregar Transmissões
    this.transmissions.splice(0, 1);
    let nextTransmissionId = 1;
    if (data.vehicleDetails?.transmissions && Array.isArray(data.vehicleDetails.transmissions)) {
      data.vehicleDetails.transmissions.forEach((transmission: any) => {
        this.transmissions.push({
          id: nextTransmissionId,
          transmission: transmission.transmission,
          fragmentTransmissionId: transmission.fragmentTransmissionId || "",
          required: transmission.required || false,
        });
        nextTransmissionId++;
      });
    }

    // Carregar Text Inputs
    this.textInputs.splice(0, 1);
    let nextTextInputId = 1;
    if (data.vehicleDetails?.textInputs && Array.isArray(data.vehicleDetails.textInputs)) {
      data.vehicleDetails.textInputs.forEach((textInput: any) => {
        this.textInputs.push({
          id: nextTextInputId,
          label: textInput.label,
          fragmentTextInputId: textInput.fragmentTextInputId || "",
          required: textInput.required || false,
        });
        nextTextInputId++;
      });
    }

    // Carregar Text Area Inputs
    this.textAreaInputs.splice(0, 1);
    let nextTextAreaInputId = 1;
    if (data.vehicleDetails?.textAreaInputs && Array.isArray(data.vehicleDetails.textAreaInputs)) {
      data.vehicleDetails.textAreaInputs.forEach((textAreaInput: any) => {
        this.textAreaInputs.push({
          id: nextTextAreaInputId,
          label: textAreaInput.label,
          fragmentTextAreaInputId: textAreaInput.fragmentTextAreaInputId || "",
          required: textAreaInput.required || false,
        });
        nextTextAreaInputId++;
      });
    }
  }

  async convertToJson(): Promise<void> {
    this.verifyBtnDisabled();
    if (this.typeFragment && !this.btn_disabled) {
      try {
        const json = {
          title: this.title,
          fragmentId: this.fragmentId,
          typeFragment: this.typeFragment,
          vehicleDetails: {
            classifications: this.classifications.map((item) => ({
              classification: item.classification,
              fragmentClassificationId: item.fragmentClassificationId,
              required: item.required,
            })),
            fuelTypes: this.fuelTypes.map((item) => ({
              fuelType: item.fuelType,
              fragmentFuelTypeId: item.fragmentFuelTypeId,
              required: item.required,
            })),
            transmissions: this.transmissions.map((item) => ({
              transmission: item.transmission,
              fragmentTransmissionId: item.fragmentTransmissionId,
              required: item.required,
            })),
            textInputs: this.textInputs.map((item) => ({
              label: item.label,
              fragmentTextInputId: item.fragmentTextInputId,
              required: item.required,
            })),
            textAreaInputs: this.textAreaInputs.map((item) => ({
              label: item.label,
              fragmentTextAreaInputId: item.fragmentTextAreaInputId,
              required: item.required,
            })),
          },
          hidden_component_id: 19, // 19 é componente DETALHAMENTO VEÍCULO
        };

        this.generatedJson = json as any;
        return this.generatedJson;
      } catch (error) {
        console.error("Erro na conversão para JSON (vehicle details)", error);
      }
    }
  }

  async store(): Promise<void> {
    try {
      const jsonPromise = this.convertToJson();
      const json = await jsonPromise;
      const success_error_msg = "Dados gravados";
      const data = {
        success_error_msg: success_error_msg,
        json: json,
      };

      this.$emit("generatedJson", data);
      this.$emit("close-modal");
    } catch (error) {
      const successErrorMsg = "Erro ao tentar gravar os dados";
      console.log("Erro ao gravar os dados (vehicle details)", error);
    }
  }
}
</script>

<style lang="css">
.default-data-base {
  border: solid #efecec 0.4px;
}

.w-3 {
  width: 10px;
}

.h-3 {
  height: 10px;
}

.mainInputs:not(:last-child) {
  margin-bottom: 15px;
}

.titleSt {
  margin-right: 200px;
}
</style>
